import React from 'react';
import BudgetChangeWorkspace from './BudgetChangeWorkspace';

/** 예산변경등록 */
export default function BudgetChangeRegister() {
  return <BudgetChangeWorkspace screenMode="register" />;
}
